type UnknownRecord = Record<string, unknown>;

const EXTENSION_MESSAGE_METHODS = new Set([
  "fetchRemoteConfigValues",
  "getRemoteConfigValues",
  "trackAnalyticsEvent",
  "trackError",
]);

const EXTENSION_REMOTE_CONFIG_SOURCES = new Set([
  "fetchRemoteConfigValues",
  "getRemoteConfigValues",
]);

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null;

const hasExtensionSender = (value: UnknownRecord): boolean => {
  const sender = value.sender;
  if (!isRecord(sender) || typeof sender.id !== "string") return false;

  return (
    "tab" in sender ||
    "frameId" in sender ||
    "documentId" in sender ||
    typeof sender.url === "string"
  );
};

const hasKnownExtensionIntent = (value: UnknownRecord): boolean => {
  const method = typeof value.method === "string" ? value.method : "";
  const source = typeof value.source === "string" ? value.source : "";
  const error = isRecord(value.error) ? value.error : null;
  const errorSource = typeof error?.source === "string" ? error.source : "";
  const errorMessage = typeof error?.message === "string" ? error.message : "";

  return (
    EXTENSION_MESSAGE_METHODS.has(method) ||
    EXTENSION_REMOTE_CONFIG_SOURCES.has(source) ||
    EXTENSION_REMOTE_CONFIG_SOURCES.has(errorSource) ||
    errorMessage.includes("[messaging] Unknown message format")
  );
};

export function isIgnoredBrowserExtensionMessage(data: unknown): boolean {
  if (!isRecord(data)) return false;
  return hasExtensionSender(data) && hasKnownExtensionIntent(data);
}

export function initBrowserExtensionNoiseGuard() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "message",
    (event) => {
      if (event.source !== window) return;
      if (!isIgnoredBrowserExtensionMessage(event.data)) return;

      event.stopImmediatePropagation();
    },
    true
  );
}
